// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"51":"locale-sc-json","64":"locale-tc-json","990":"locale-en-json"}[chunkId] + "." + {"51":"3842c698","64":"aeacb14f","990":"b55b52be"}[chunkId] + ".js";
};